package ru.villawonka.app.presentation.model

import ru.villawonka.app.domain.model.AccommodationAdditionDomain
import ru.villawonka.app.resources.AppResources

sealed class AccommodationAdditionUIModel {
    abstract val key: String
    abstract val value: String

    class UtilityBillsIncluded : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionUtilityBillsIncluded
        override val value: String = AppResources.strings.additionIncluded
    }

    class Pool : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionPool
        override val value: String = AppResources.strings.additionAvailable
    }

    class Parking : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionParking
        override val value: String = AppResources.strings.additionAvailable
    }

    class Cleaning : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionCleaning
        override val value: String = AppResources.strings.additionIncluded
    }

    class WiFi : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionWiFi
        override val value: String = AppResources.strings.additionAvailable
    }

    class NearGym : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionNearGym
        override val value: String = AppResources.strings.additionNearby
    }

    class NearCafe : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionNearCafe
        override val value: String = AppResources.strings.additionNearby
    }

    class AirCondition : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionAirCondition
        override val value: String = AppResources.strings.additionAvailable
    }

    class NearBeach : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionNearBeach
        override val value: String = AppResources.strings.additionNearby
    }

    class ClosedLivingRoom : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionClosedLivingRoom
        override val value: String = AppResources.strings.additionAvailable
    }

    class Terrace : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionTerrace
        override val value: String = AppResources.strings.additionAvailable
    }

    class Jacuzzi : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionJacuzzi
        override val value: String = AppResources.strings.additionAvailable
    }

    class WashingMachine : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionWashingMachine
        override val value: String = AppResources.strings.additionAvailable
    }

    class TV : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionTV
        override val value: String = AppResources.strings.additionAvailable
    }

    class Safe : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionSafe
        override val value: String = AppResources.strings.additionAvailable
    }


    class ClosedKitchen : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionClosedKitchen
        override val value: String = AppResources.strings.additionAvailable
    }

    class VideoSurveillance : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionVideoSurveillance
        override val value: String = AppResources.strings.additionAvailable
    }

    class BarbecueArea : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionBarbecueArea
        override val value: String = AppResources.strings.additionAvailable
    }

    class DrinkWaterIncluded : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionDrinkWaterIncluded
        override val value: String = AppResources.strings.additionIncluded
    }

    class HasDiscount : AccommodationAdditionUIModel() {
        override val key: String = AppResources.strings.accommodationAdditionHasDiscount
        override val value: String = AppResources.strings.additionAvailable
    }
}

fun AccommodationAdditionDomain.toUIModel(): AccommodationAdditionUIModel = when (this) {
    AccommodationAdditionDomain.PARKING -> AccommodationAdditionUIModel.Parking()
    AccommodationAdditionDomain.NEAR_GYM -> AccommodationAdditionUIModel.NearGym()
    AccommodationAdditionDomain.NEAR_CAFE -> AccommodationAdditionUIModel.NearCafe()
    AccommodationAdditionDomain.AIR_CONDITION -> AccommodationAdditionUIModel.AirCondition()
    AccommodationAdditionDomain.NEAR_BEACH -> AccommodationAdditionUIModel.NearBeach()
    AccommodationAdditionDomain.CLEANING -> AccommodationAdditionUIModel.Cleaning()
    AccommodationAdditionDomain.JACUZZI -> AccommodationAdditionUIModel.Jacuzzi()
    AccommodationAdditionDomain.CLOSED_LIVING_ROOM -> AccommodationAdditionUIModel.ClosedLivingRoom()
    AccommodationAdditionDomain.SAFE -> AccommodationAdditionUIModel.Safe()
    AccommodationAdditionDomain.CLOSED_KITCHEN -> AccommodationAdditionUIModel.ClosedKitchen()
    AccommodationAdditionDomain.TERRACE -> AccommodationAdditionUIModel.Terrace()
    AccommodationAdditionDomain.TV -> AccommodationAdditionUIModel.TV()
    AccommodationAdditionDomain.WASHING_MACHINE -> AccommodationAdditionUIModel.WashingMachine()
    AccommodationAdditionDomain.WIFI -> AccommodationAdditionUIModel.WiFi()
    AccommodationAdditionDomain.POOL -> AccommodationAdditionUIModel.Pool()
    AccommodationAdditionDomain.UTILITY_BILLS_INCLUDED -> AccommodationAdditionUIModel.UtilityBillsIncluded()
    AccommodationAdditionDomain.VIDEO_SURVEILLANCE -> AccommodationAdditionUIModel.VideoSurveillance()
    AccommodationAdditionDomain.BARBECUE_AREA -> AccommodationAdditionUIModel.BarbecueArea()
    AccommodationAdditionDomain.DRINK_WATER_INCLUDED -> AccommodationAdditionUIModel.DrinkWaterIncluded()
    AccommodationAdditionDomain.HAS_DISCOUNT -> AccommodationAdditionUIModel.HasDiscount()
}